import React from "react";

const ReplaceIcon = ({
  size = 24,
  className,
  strokeWidth = 2,
  strokeColor = "#0C4E55",
}) => {
  return (
    <span className={className}>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width={size}
        height={size}
        fill="none"
        viewBox="0 0 24 24"
      >
        <path
          d="M20 7H4M4 7L8 3M4 7L8 11"
          stroke={strokeColor}
          strokeWidth={strokeWidth}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M4 17H20M20 17L16 13M20 17L16 21"
          stroke={strokeColor}
          strokeWidth={strokeWidth}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </span>
  );
};

export default ReplaceIcon;
